module.exports = __webpack_public_path__ + "media/images/app/visitors/couture/how-it-works/step1-c8aefe039384af8525288af357cf1413.svg";